import {
  Abdullah,
  anselme,
  earnestVinas,
  EnocDashboard,
  fangyuWu,
  hemantG,
  ivanStantic,
  mananNewBulb,
  philipR,
  pulkitJain,
  RickGottlieb,
  victorK,
  YamahaMusic,
} from "../assets/images";

const testimonialsHomeData = [
  {
    testimonial:
      "Excellent communication, everything went exactly as we agreed upfront, and all deliverables were on time.",
    name: "Ivan Stantic",
    designation: "Project Manager -",
    company: "Thrivea",
    image: ivanStantic,
  },
  {
    testimonial:
      "Outstanding developer. Exceptionally fast and professional. Communication was clear and proactive throughout the entire project. Delivered high-quality code ahead of deadlines, with attention to detail and clean structure. Would absolutely work with again and highly recommend to anyone looking for top-tier frontend expertise.",
    name: "Rick Gottlieb",
    designation: "Founder -",
    company: "OpenMd openmd.com",
    image: RickGottlieb,
  },
  {
    testimonial:
      "So effective and proactive! Deep consistently delivers high-quality work with great efficiency. He anticipates needs, communicates clearly, and makes collaboration seamless. I’ll definitely continue working with him.",
    name: "Ernest Vinas",
    designation: "Founder -",
    company: "Debook",
    image: earnestVinas,
  },
  {
    testimonial:
      "Deep went above and beyond on this project , even doing things he didn’t have to, just to make sure everything was polished and working smoothly. His attention to detail, communication, and dedication really stood out. It was a pleasure working with him, and we’re definitely looking forward to future collaborations !",
    name: "Enoc Tagro",
    designation: "Founder -",
    company: "Enoc Dashboard Comp..",
    image: EnocDashboard,
  },
  {
    testimonial:
      "Deep is highly professional, skilled at what he does, and incredibly easy to work with. He brings both technical expertise and a collaborative mindset, making every project smooth and successful.",
    name: "Anselme mucunguzi",
    designation: "Co Founder",
    company: "Cathy-Doll & Baby-Bright",
    image: anselme,
  },
  {
    testimonial:
      "Working with Deep on the Yamaha Music Europe website was an outstanding experience. He demonstrated exceptional attention to detail, delivered a seamless and responsive frontend, and maintained excellent communication throughout. His ability to translate complex design into smooth digital interactions truly elevated the user experience. Highly recommended for any high-profile web development project.",
    name: "Yamaha Music",
    designation: "Company",
    company: "Yamaha Music Europe",
    image: YamahaMusic,
  },
  {
    testimonial:
      "I am thrilled to give you a 5-star rating for your exceptional work as a full-stack developer. Your technical expertise, proactive problem-solving, and dedication to client satisfaction have truly stood out. Working with you has been a pleasure, and I confidently recommend your services to others.",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
  {
    testimonial:
      "Clean job. Quick work speed and very responsive once contract commenced. On time job completion.  Pleased with delivery, thank you.! Deep.",
    name: "Fangyu Wu",
    designation: "CEO",
    company: "MilkGarage",
    image: fangyuWu,
  },
];

const testimonialsData = [
  {
    testimonial:
      "Excellent communication, everything went exactly as we agreed upfront, and all deliverables were on time.",
    name: "Ivan Stantic",
    designation: "Project Manager -",
    company: "Thrivea",
    image: ivanStantic,
  },
  {
    testimonial:
      "Outstanding developer. Exceptionally fast and professional. Communication was clear and proactive throughout the entire project. Delivered high-quality code ahead of deadlines, with attention to detail and clean structure. Would absolutely work with again and highly recommend to anyone looking for top-tier frontend expertise.",
    name: "Rick Gottlieb",
    designation: "Founder -",
    company: "OpenMd - openmd.com",
    image: RickGottlieb,
  },
  {
    testimonial:
      "So effective and proactive! Deep consistently delivers high-quality work with great efficiency. He anticipates needs, communicates clearly, and makes collaboration seamless. I’ll definitely continue working with him.",
    name: "Ernest Vinas",
    designation: "Founder -",
    company: "Debook",
    image: earnestVinas,
  },
  {
    testimonial:
      "Deep went above and beyond on this project , even doing things he didn’t have to, just to make sure everything was polished and working smoothly. His attention to detail, communication, and dedication really stood out. It was a pleasure working with him, and we’re definitely looking forward to future collaborations !",
    name: "Enoc Tagro",
    designation: "Founder -",
    company: "Enoc Dashboard Comp..",
    image: EnocDashboard,
  },
  {
    testimonial:
      "Deep is highly professional, skilled at what he does, and incredibly easy to work with. He brings both technical expertise and a collaborative mindset, making every project smooth and successful.",
    name: "Anselme mucunguzi",
    designation: "Co Founder",
    company: "Cathy-Doll & Baby-Bright",
    image: anselme,
  },
  {
    testimonial:
      "Working with Deep on the Yamaha Music Europe website was an outstanding experience. He demonstrated exceptional attention to detail, delivered a seamless and responsive frontend, and maintained excellent communication throughout. His ability to translate complex design into smooth digital interactions truly elevated the user experience. Highly recommended for any high-profile web development project.",
    name: "Yamaha Music",
    designation: "Company",
    company: "Yamaha Music Europe",
    image: YamahaMusic,
  },
  {
    testimonial:
      "I am thrilled to give you a 5-star rating for your exceptional work as a full-stack developer. Your technical expertise, proactive problem-solving, and dedication to client satisfaction have truly stood out. Working with you has been a pleasure, and I confidently recommend your services to others.",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
  {
    testimonial:
      "Deep is doing a great job! The webpage is fully responsive, loads quickly, and looks great across all devices. He communicates well, delivers on time, and shows real attention to detail. Highly recommended for any frontend or full-stack work!",
    name: "Pulkit Jain",
    designation: "Founder -",
    company: "VihaTech & Diffr.co.",
    image: pulkitJain,
  },
  {
    testimonial:
      "Yet another great job. Deep was very responsive and fast, creating an essential set of function, as well as UX/UI enhancements to our website and CMS. Highly recommended, and will be hiring again for future phases!",
    name: "Fangyu Wu",
    designation: "CEO",
    company: "MilkGarage",
    image: fangyuWu,
  },
  {
    testimonial:
      "Clean job. Quick work speed and very responsive once contract commenced. On time job completion.  Pleased with delivery, thank you.! Deep.",
    name: "Fangyu Wu",
    designation: "CEO",
    company: "MilkGarage",
    image: fangyuWu,
  },
  {
    testimonial:
      "Deep is quick and easy to work with. I trust working with him. and he always does great work! Thanks for you work and i would like to recommend your work to your other clients.",
    name: "Philip Ruffini",
    designation: "Founder -",
    company: "Hackingpm",
    image: philipR,
  },
  {
    testimonial: "Deep always does great work!",
    name: "Philip Ruffini",
    designation: "Founder -",
    company: "Hackingpm",
    image: philipR,
  },
  {
    testimonial:
      "Deep has shown professionalism throughout the project and finished it quickly. he guided us with the proper things that needs to be done to ensure we dont get off the track. highly recommended.",
    name: "Victor KON",
    designation: "BMC",
    company: "Business Ignites",
    image: victorK,
  },
  {
    testimonial:
      "It was nice working with Deep. He tried to understand the requirement, accommodated suggestions as per the need with his ideas. He has excellent communication skills and very responsive. He has good skills in CSS, Reacts, and responsive design.",
    name: "Hemant Gaur",
    designation: "PM",
    company: "Appbuddy Technology",
    image: hemantG,
  },
  {
    testimonial:
      "Deep was extremely responsive and regular. He completed the job on time and as required. Got an email template developed. He gave me various versions and wasn't hesitant to rework. Also helped by sharing extra material and advice. Would rehire any given day. Thanks Deep.",
    name: "Manan Maheshwari",
    designation: "CEO",
    company: "News Bulb",
    image: mananNewBulb,
  },
  {
    testimonial:
      "It was great working with Deep. As promised he delivered the project in time and maintained the quality of the work.",
    name: "Manan Maheshwari",
    designation: "CEO",
    company: "News Bulb",
    image: mananNewBulb,
  },
  {
    testimonial:
      "we have been working with each other since 2 and half years. in the last 12 months we completed many projects with final stage with deep. a truly dedicated person to his work i had ever seen before. He is very up to date with the technology. Completed my multiple system very quickly. A great source of knowledge and very easy to communicate with. He understood the requirements well and delivered everything before the time. Smooth workflow and great outcome. I would definitely work with him in the future.",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
  {
    testimonial:
      "It was a great experience working with Deep, very easy to communicate with. His skills definitely define him as a great developer. He is really talented and has delivered better than one can expect. I will work with him in future surely. Thank you for everything deep. Cheers!",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
  {
    testimonial:
      "Deep is a pleasure to work with, he is excellent with programming languages, and Responsive Web Design. Very talented, great problem solving skills, and quick execution. he provides amazingly clear communication, and he very promptly to replied to any questions I had. Also, he is very polite and friendly, which goes a long way for me. He is a true professional and I would highly recommend him for the skills mentioned above. he goes above and beyond and provides excellent work quickly and efficiently. He is a valuable resource and I plan to hire him for future projects. Thank You! : )",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
  {
    testimonial:
      "Wow... Mr. Deep, He is very up to date with the technology. A great source of knowledge and very easy to communicate with. He understood the requirements well and delivered everything before the time. Smooth workflow and great outcome. I would definitely work with him in the future.",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
  {
    testimonial:
      "Mr. Deep Kapadia is very good web designer and frontend developer. He made design and convert to HTML format for our website. We are very happy with the work provided by him. I advice to deal with him.",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
  {
    testimonial:
      "Again Succesful project with Deep. he is excellent with back-end & Front-end, CRM & Responsive Web Design. Very talented, great problem solving skills, and quick execution.He is a true professional and I would highly recommend him for the skills mentioned above. He is a valuable resource and I plan to hire him for future projects.",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
  {
    testimonial:
      "He is excellent with Front-end setup & other things. He made nice Designed E-mail working for my contact us form. and he is a very responsive person. I would like to recommend him to everyone. He is my go-to-guy and valuable resource and I plan to hire him for future projects.",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
  {
    testimonial:
      "Excellent work. Successfully completed this project with true professional. i told him to convert website language to arabic and he did extremely good job. he is extremely good with his work, excellent skills and his quick execution for all tasks. he is powerful with his skills and talent. I would highly recommend him to everyone for Front-end and Back-end development and website design as well. and I would also like to hire him again in future.",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
  {
    testimonial:
      "After numbers of projects, i gave IOS project to Deep. he was outstanding in IOS app development. he did a very good job and I would definitely hire him again in the future.",
    name: "Sir. Abdullah Alburadi",
    designation: "CEO",
    company: "Global Academies, Online Properties",
    image: Abdullah,
  },
];

export {testimonialsHomeData, testimonialsData};
